export const HERO_COLORS = {
  white: {
    deep: 'gray.50',
    soft: 'gray.50',
    gentle: 'whiteAlpha.700',
    border: 'whiteAlpha.200',
  },
  gray: {
    deep: 'gray.600',
    soft: 'blackAlpha.700',
    gentle: 'blackAlpha.700',
    border: 'blackAlpha.200',
  },
};

export type HeroColorScheme = keyof typeof HERO_COLORS;
